// Dev version
// export default (text, showDefault = true) => {
//   if (!text && showDefault) {
//     return '$0.0000';
//   }

//   if (!text && !showDefault) return text;
//   const parts = text.toFixed(2).split('.');
//   const val = `${parts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
//     (parts[1] ? '.' + parts[1] : '')}`;
//   return '$' + val;
// };

//v0.1
export default (text, showDefault = true) => {
  if (!text && showDefault) {
    return '$0.0000';
  }

  if (!text && !showDefault) return text;

  const parts =
    text.constructor === String
      ? text.includes('$')
        ? text.replace('$', '').split('.')
        : text.constructor === String
        ? text.toString().split('.')
        : text.toFixed(2).split('.')
      : text.toString().split('.');

  const val = `${parts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
    (parts[1] ? '.' + parts[1] : '')}`;

  return '$' + val;
};
